import { forwardRef, useImperativeHandle, useRef } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { HELPER_TEXT_TYPES } from '@icp/form-renderer-core';
import { useTranslation } from 'react-i18next';
import { useElementDecorator, useIsInDesign } from '../FormRenderCtx';
import { useClassName } from '../hooks';
import FieldTitle from '../FieldTitle';
import FormHelperText from '../FormHelperText';
import { withFieldWrapper } from '../fieldWrapper';

const JoinElement = forwardRef(function JoinElement(props, ref) {
  const {
    keyPath,
    id,
    className: classNameProp,
    title,
    value,
    helpers,
    style,
    fieldTitleProps,
    componentProps = {},
  } = props || {};

  const isInDesign = useIsInDesign();
  const ElementDecorator = useElementDecorator();
  const className = useClassName(classNameProp);
  const classNameComp = useClassName(componentProps.className);
  const nodeRef = useRef(null);

  const { t } = useTranslation(['icp-form-renderer']);

  useImperativeHandle(
    ref,
    () => ({
      node: nodeRef.current,
    }),
    [],
  );

  return (
    <ElementDecorator keyPath={keyPath} id={id}>
      <div
        className={clsx('join-element', 'input-element', 'form-element', className)}
        style={style}
        ref={nodeRef}
      >
        <FieldTitle {...fieldTitleProps}>{title}</FieldTitle>
        <div>
          <div className={clsx('join-field-value', classNameComp)} style={componentProps.style}>
            {isInDesign ? `{{ ${t('join.placeholder')} }}` : value}
          </div>
          <FormHelperText helpers={helpers} />
        </div>
      </div>
    </ElementDecorator>
  );
});

JoinElement.propTypes = {
  keyPath: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  id: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  fieldConfig: PropTypes.shape({
    pbcToken: PropTypes.string,
    formEntityToken: PropTypes.string,
    displayFieldToken: PropTypes.string,
    joinConditions: PropTypes.arrayOf(PropTypes.shape({})),
    joinFormQueryPayload: PropTypes.shape({}),
  }),
  value: PropTypes.string,
  helpers: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.oneOf(HELPER_TEXT_TYPES),
      text: PropTypes.string,
    }),
  ),
  style: PropTypes.shape({}),
  fieldTitleProps: PropTypes.shape({
    showColon: PropTypes.bool,
  }),
  componentProps: PropTypes.shape({
    className: PropTypes.string,
    style: PropTypes.string,
  }),
};

JoinElement.displayName = 'Join';

export default withFieldWrapper(JoinElement);
